module.exports = __webpack_public_path__ + "static/media/avenir-next-regular.ff0ed1c0.ttf";